<template>
  <div class="button" :style="`width:${width/100}rem;height:${height/100}rem;line-height:${height/100}rem;font-size:${fontSize/100}rem`"  @click="onClick">{{text}}</div>
</template>

<script>
export default {
  name: 'dbutton',
  props: {
    text: {
      type: String,
      default: '下载游戏助手'
    },
    width: {
      type: Number,
      default: 236
    },
    height: {
      type: Number,
      default: 87
    },
    id: {
      type: String,
      default: ''
    },
    fontSize: {
      type: Number,
      default: 28
    }
  },
  data () {
    return {

    }
  },

  methods: {
    onClick () {
      window.monitor.trackEvent('page_click', {})
      location.href = `${location.protocol}//simulator.mobilem.360.cn/web/appDown?t=${+new Date()}&m2=${localStorage.getItem('dm') || ''}${this.id ? '&id=' + this.id : ''}&ch=2010&from_page=home_download&sc=${window.screen.width + 'x' + window.screen.height}`
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.button{
  display: block;
  font-weight: bold;
  font-size: 28px;
  color: #070c19;
  background: #ffdc00;
  border-radius: 44px;
  text-align: center;
  overflow: hidden;
  cursor: pointer;
}
.button:hover{
  background: #ffeb6f;
}
</style>
